// extracted by mini-css-extract-plugin
module.exports = {"poweredByHuggg":"powered-by-huggg_poweredByHuggg__1maR_","logo":"powered-by-huggg_logo__UUUcP"};